<p-dialog
	modal
	styleClass="w-[95%] max-w-xl sm:w-lg"
	header="Select Account"
	[closable]="!loading()"
	[(visible)]="visible"
	(onHide)="closeDialog()"
>
	<ng-template #content>
		<div class="mb-4 text-center">
			<i class="pi pi-microsoft mb-2 text-4xl! text-blue-500"></i>
			<p class="text-surface-600">
				Multiple accounts found with your email.<br />
				Please select the account you want to link with {{ providerLabel() }}.
			</p>
		</div>

		<p-fieldset legend="Available Accounts">
			<div class="flex flex-col gap-3">
				@for (candidate of candidates(); track candidate.id) {
					<button
						type="button"
						class="border-surface-200 hover:bg-surface-50 flex w-full cursor-pointer items-center gap-3 rounded-lg border p-3 text-left transition-colors"
						[disabled]="loading()"
						(click)="selectAccount(candidate)"
					>
						<p-avatar
							shape="circle"
							class="h-10! w-10! text-sm!"
							[label]="getInitial(candidate.username)"
							[style]="getAvatarStyle(candidate.roles)"
						/>
						<div class="flex-1">
							<div class="text-surface-900 font-semibold">{{ candidate.username }}</div>
							<div class="text-surface-500 text-sm">{{ candidate.fullName }}</div>
							<div class="mt-1 flex flex-wrap gap-1">
								@for (role of candidate.roles; track role) {
									<span class="bg-surface-100 text-surface-600 rounded px-2 py-0.5 text-xs">
										{{ role }}
									</span>
								}
							</div>
						</div>
						<i class="pi pi-chevron-right text-surface-400"></i>
					</button>
				}
			</div>
		</p-fieldset>
	</ng-template>

	<ng-template #footer>
		<p-button
			label="Cancel"
			icon="pi pi-times"
			severity="secondary"
			outlined
			[disabled]="loading()"
			(click)="closeDialog()"
		></p-button>
	</ng-template>
</p-dialog>
